import { z } from 'zod';

/** A question reached the operator unanswered (IMM-1413.4): asked mid-flight, on a parked end, or asked again. */
export const FleetQuestionAskedPayloadSchema = z.object({
  questionId: z.uuid(),
  /** `IMM-123`, from the job's key; the whole key when it names no ticket. */
  ticket: z.string(),
  occurredAt: z.iso.datetime(),
});

export type FleetQuestionAskedPayload = z.infer<typeof FleetQuestionAskedPayloadSchema>;
